import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { replaceAll } from '../../tools/index';
import { people } from '../../constants/images';
import { ReadMoreOrLess } from './buttons';
import { connect } from 'react-redux';
import AudioPlayer from '../AudioPlayer';

@connect(
	state => ({
		translations: state.setup.translations,
	}),
)
export default class Copy extends Component {
	static PropTypes = {
		window: PropTypes.object,
		user: PropTypes.object,
		players: PropTypes.object,
		countryCode: PropTypes.string
	};

	constructor(props) {
		super(props);

		this.state = {
			isReadingMore: false,
		}
	}

	toggleReadMore = () => {
		this.setState((state) => ({ isReadingMore: !state.isReadingMore }))
	}

	componentDidUpdate(prevProps) {
		// reset once there is a new text to render
		if (prevProps.window.current.paragraph !== this.props.window.current.paragraph) {
			this.setState({ isReadingMore: false })
		}
	}

	render() {
		const props = this.props;
		const { heading, paragraph, contactAvatar, hasReadMoreText = false, voiceOver } = props.window.current;
		const { countryCode } = props;

		const replaceableStrings = {
			'{{name participant}}': props.user.firstName
		};

		if (props.window.current.players && props.window.current.players.length > 1) {
			replaceableStrings['{{role other party}}'] = props.players[props.window.current.players[1]].name[countryCode];
		}

		const paragraphs = Array.isArray(paragraph) ? paragraph : [];

		const hasVoiceOver = voiceOver && voiceOver[countryCode];

		return (
			<div className="copy container">
				<CopyHeading heading={heading}
					contactAvatar={contactAvatar}
					replaceableStrings={replaceableStrings}
					countryCode={props.countryCode} />

				<div className={`explanationContainer ${hasReadMoreText && !this.state.isReadingMore ? "truncate" : ""}`}>
					{
						paragraphs.map((entry, index) => {
							if (Object.keys(entry)[0] === 'ul') {
								const list = entry['ul'].map((li, liIndex) =>
									<li key={`list-${liIndex}`} className={`${hasReadMoreText && index > 0 ? "text-grey-1" : ""}`}>
										{replaceAll(li[props.countryCode], replaceableStrings)}
									</li>)

								return <ul key={`ul-${index}`}>{list}</ul>
							} else {
								return (
									<p key={`paragraph-${index}`} className={`${hasReadMoreText && index > 0 ? "text-grey-1" : ""}`}>
										{replaceAll(entry[props.countryCode], replaceableStrings)}
									</p>
								)
							}
						}
						)
					}

				</div>


				{hasReadMoreText && (
					<div className="readMoreOrLess container">
						<div className={`content ${this.state.isReadingMore ? "" : "shadowed"}`}>
							<ReadMoreOrLess
								onMouseDown={this.toggleReadMore}
								text={this.state.isReadingMore ? props.translations.readLess[props.countryCode] : props.translations.readMore[props.countryCode]}
								isExpanded={this.state.isReadingMore}
							/>
						</div>
					</div>
				)}

				{hasVoiceOver ? (
					<AudioPlayer src={voiceOver[countryCode]} translations={props.translations} countryCode={props.countryCode} />
				) : null}

				{props.children}
			</div>
		);
	}
}


const CopySplit = (props) => {
	const { heading, paragraph, contactAvatar } = props.window.current;
	const { countryCode } = props;

	const replaceableStrings = {
		'{{name participant}}': props.user.firstName
	};

	if (props.window.current.players && props.window.current.players.length > 1) {
		replaceableStrings['{{role other party}}'] = props.players[props.window.current.players[1]].name[countryCode];
	}

	return (
		<div className={'copy-split'}>
			<div className={'copy-split__question'}>
				<CopyHeading heading={heading}
					contactAvatar={contactAvatar}
					replaceableStrings={replaceableStrings}
					countryCode={props.countryCode} />
				{paragraph && paragraph.map((entry, index) => <p
					key={index}>{replaceAll(entry[props.countryCode], replaceableStrings)}</p>)}
			</div>
			<div className={'copy-split__answers'}>
				{props.children}
			</div>
		</div>
	);
};

Copy.propTypes = {
	window: PropTypes.object,
	user: PropTypes.object,
	players: PropTypes.object,
	countryCode: PropTypes.string
};

const CopyHeading = ({ heading, contactAvatar, replaceableStrings, countryCode }) => {
	let Heading;

	if (contactAvatar && Array.isArray(contactAvatar)) {
		Heading = (
			<div className={'copy-avatar'}>
				{
					contactAvatar.map((item, index) => (
						<div key={`person-${index}`}>
							<img src={people[item]} />
							<p>{item}</p>
						</div>
					))
				}
				{heading && <h1>{replaceAll(heading[countryCode], replaceableStrings)}</h1>}
			</div>
		)
	} else if (contactAvatar) {
		Heading = (
			<div className={'copy-avatar'}>
				<div>
					<img src={people[contactAvatar]} />
					<p>{contactAvatar}</p>
				</div>
				{heading && <h1>{replaceAll(heading[countryCode], replaceableStrings)}</h1>}
			</div>
		)
	} else if (heading) {
		Heading = <h1>{replaceAll(heading[countryCode], replaceableStrings)}</h1>
	}

	return Heading;
}

export { Copy, CopySplit };
